import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { ServiceAssertionPerformanceReferenceData } from "@idw-types/state/service-assertion-performance-state";

export const getServiceAssertionPerformanceReferenceDataRequest = async (): Promise<{ data: ServiceAssertionPerformanceReferenceData; error: any }> => {
    const route = apiRoutes.reports.serviceAssertionPerformanceComparison.referenceData;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};